import Id from './AdManagerId';

const SlotSizes = {
    [Id.Footer]: [
        [[0, 0], []],
        [[1035, 0], [728, 90]],
    ],
    [Id.FooterMobile]: [
        [[0, 0], [320, 50]],
        [[1035, 0], []],
    ],
    [Id.Sidebar]: [
        [[0, 0], []],
        [[1035, 0], [160, 600]],
    ],
    [Id.Promo]: [
        [[0, 0], [767, 84]],
        [[768, 0], [990, 50]],
        [[1415, 0], [1370, 50]],
    ],
    [Id.Category1]: [
        [[0, 0], [710, 180]],
        [[768, 0], [790, 180]],
        [[1415, 0], [1046, 240]],
    ],
    [Id.Category2]: [
        [[0, 0], [710, 180]],
        [[768, 0], [790, 180]],
        [[1415, 0], [1046, 240]],
    ],
    [Id.Category3]: [
        [[0, 0], [710, 180]],
        [[768, 0], [790, 180]],
        [[1415, 0], [1046, 240]],
    ],
    [Id.CategoryMid]: [
        [[0, 0], [770, 355]],
        [[768, 0], [790, 180]],
        [[1415, 0], [1046, 240]],
    ],
    [Id.ProductMid]: [
        [[0, 0], []],
        [[1035, 0], [970, 90]],
    ],
    [Id.ProductMidMobile]: [
        [[0, 0], [320, 50]],
        [[1035, 0], []],
    ],
    [Id.HomeSlider1]: [
        [[0, 0], [770, 510]],
        [[1035, 0], [990, 440]],
        [[1415, 0], [1370, 520]],
    ],
    [Id.HomeSlider2]: [
        [[0, 0], [770, 510]],
        [[1035, 0], [990, 440]],
        [[1415, 0], [1370, 520]],
    ],
    [Id.HomeSlider3]: [
        [[0, 0], [770, 510]],
        [[1035, 0], [990, 440]],
        [[1415, 0], [1370, 520]],
    ],
    [Id.HomeSlider4]: [
        [[0, 0], [770, 510]],
        [[1035, 0], [990, 440]],
        [[1415, 0], [1370, 520]],
    ],
    [Id.HomeMid1]: [
        [[0, 0], [740, 500]],
        [[768, 0], [990, 310]],
        [[1415, 0], [1370, 410]],
    ],
    [Id.HomeMid21]: [
        [[0, 0], [740, 470]],
        [[768, 0], [490, 310]],
        [[1415, 0], [675, 410]],
    ],
    [Id.HomeMid22]: [
        [[0, 0], [740, 470]],
        [[768, 0], [490, 310]],
        [[1415, 0], [675, 410]],
    ],
    [Id.HomeMid31]: [
        [[0, 0], [740, 310]],
        [[768, 0], [320, 310]],
        [[1415, 0], [445, 410]],
    ],
    [Id.HomeMid32]: [
        [[0, 0], [740, 310]],
        [[768, 0], [320, 310]],
        [[1415, 0], [445, 410]],
    ],
    [Id.HomeMid33]: [
        [[0, 0], [740, 310]],
        [[768, 0], [320, 310]],
        [[1415, 0], [445, 410]],
    ],

    // Category Landings

    [Id.CategoryLandingTopSlider1]: [
        [[0, 0], [390, 444]],
        [[768, 0], [1370, 520]],
    ],
    [Id.CategoryLandingTopSlider2]: [
        [[0, 0], [390, 444]],
        [[768, 0], [1370, 520]],
    ],
    [Id.CategoryLandingTopSlider3]: [
        [[0, 0], [390, 444]],
        [[768, 0], [1370, 520]],
    ],
    [Id.CategoryLandingTopSlider4]: [
        [[0, 0], [390, 444]],
        [[768, 0], [1370, 520]],
    ],

    [Id.CategoryLandingFeaturedWeek1]: [
        [[0, 0], [365, 450]],
        [[1035, 0], [445, 542]],
    ],
    [Id.CategoryLandingFeaturedWeek2]: [
        [[0, 0], [365, 450]],
        [[1035, 0], [445, 542]],
    ],
    [Id.CategoryLandingFeaturedWeek3]: [
        [[0, 0], [365, 450]],
        [[1035, 0], [445, 542]],
    ],

    [Id.CategoryLandingMiddle1]: [
        [[0, 0], [310, 450]],
        [[1035, 0], [678, 545]],
    ],
    [Id.CategoryLandingMiddle2]: [
        [[0, 0], [310, 450]],
        [[1035, 0], [678, 545]],
    ],
    [Id.CategoryLandingMiddle3]: [
        [[0, 0], [310, 450]],
        [[1035, 0], [678, 545]],
    ],
    [Id.CategoryLandingMiddle4]: [
        [[0, 0], [310, 450]],
        [[1035, 0], [678, 545]],
    ],

    [Id.CategoryLandingFeatured]: [
        [[0, 0], [365, 450]],
        [[768, 0], [1370, 545]],
    ],

    [Id.CategoryLandingBrand1]: [
        [[0, 0], [155, 200]],
        [[1035, 0], [333, 415]],
    ],
    [Id.CategoryLandingBrand2]: [
        [[0, 0], [155, 200]],
        [[1035, 0], [333, 415]],
    ],
    [Id.CategoryLandingBrand3]: [
        [[0, 0], [155, 200]],
        [[1035, 0], [333, 415]],
    ],
    [Id.CategoryLandingBrand4]: [
        [[0, 0], [155, 200]],
        [[1035, 0], [333, 415]],
    ],
    [Id.CategoryLandingBrand5]: [
        [[0, 0], [155, 200]],
        [[1035, 0], [333, 415]],
    ],
    [Id.CategoryLandingBrand6]: [
        [[0, 0], [155, 200]],
        [[1035, 0], [333, 415]],
    ],
    [Id.CategoryLandingBrand7]: [
        [[0, 0], [155, 200]],
        [[1035, 0], [333, 415]],
    ],
    [Id.CategoryLandingBrand8]: [
        [[0, 0], [155, 200]],
        [[1035, 0], [333, 415]],
    ],
};

export default SlotSizes;